import { useEffect } from "react";
import { useLocation } from "wouter";

/** Discourages casual saving; public images cannot be made copy-proof. */
export function ImageProtection() {
  const [location] = useLocation();

  useEffect(() => {
    // Leave staff evidence and customer documents accessible.
    if (/^\/(admin|engineer|portal)(\/|$)/.test(location)) return;
    document.documentElement.classList.add("protect-public-images");
    const preventImageAction = (event: Event) => {
      if (event.target instanceof Element && event.target.closest("img, picture")) {
        event.preventDefault();
      }
    };
    document.addEventListener("contextmenu", preventImageAction, true);
    document.addEventListener("dragstart", preventImageAction, true);
    return () => {
      document.documentElement.classList.remove("protect-public-images");
      document.removeEventListener("contextmenu", preventImageAction, true);
      document.removeEventListener("dragstart", preventImageAction, true);
    };
  }, [location]);

  return null;
}
